<template>
	<div class="report-pay-button-box">
		<button class="report-pay-button" @click="clickPay">{{btnText == '' ? bText : btnText}}</button>
		<div v-if="bData.freeUser && bData.freeUser==1" class="report-pay-free"><i class="iconfont icon-dolar"></i>你有祈福求测免费券</div>
		<!-- <div v-else class="report-pay-discount"><i class="iconfont icon-dolar"></i>你有一张50元优惠券</div> -->
		<div class="report-pay-sub">
			<span v-if="bData.freeUser && bData.freeUser==1" class="text1">使用后价格0元</span>
			<span v-else class="text1">优惠价{{pPrice1}}元</span>
			<span class="text2">原价{{pPrice2}}元</span>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			bData: {
				type: Object,
				default: {}
			},
			bPid: {
				type: Number,
				default: 0
			},
			bText: {
				type: String,
				default: ''
			},
			btnFunc: {
				type: Function,
				default: undefined
			}
		},
		data() {
			return {
				locked: false,
				pPrice1: '',
				pPrice2: '',
				btnText: ''
			}
		},
		mounted() {
			setTimeout(function() {
				this.initData();
			}.bind(this), 20)
		},
		methods: {
			initData() {
				var productList = this.$store.state.pay.productList, 
					curData = this.bData, pData = {};
				productList.forEach(element => {
					pData = element.pid == curData.pid ? element : pData;
				});
				this.pPrice1 = parseFloat(pData.price/100).toString();
				this.pPrice2 = parseFloat(pData.rate_price/100).toString();
				// console.error('initData------', this.bData.pid, pData, this.bPid)
			},
			clickPay() {
				if(this.locked) { return; }
				this.locked = true;
				setTimeout(function() {
					this.locked = false;
				}.bind(this), 3000);
				// 防止连续点击
				this.btnText = '报告解锁生成中...';
				
				var me = this;
				if(this.btnFunc && typeof(this.btnFunc) == 'function') {
					this.btnFunc({
						bData: me.bData,
						bPid: me.bPid,
						bCb: () => {
							this.btnText = '';
						}
					});
				}
			}
		}
	}
</script>

<style>
</style>
